export default "__VITE_ASSET__DeZiHMX3__"